// extracted by mini-css-extract-plugin
export default {"container":"Block_container__gwe+t","textWrapper":"Block_textWrapper__Oeak4","first":"Block_first__jxQ3m","second":"Block_second__NGq3j","third":"Block_third__RHin0"};